<template>
	<v-layout row wrap align-center white primary--text class="section-addresses">
		<v-flex xs12 class="container">
			<v-layout wrap>
				<v-flex xs12 md4>
					<h2 class="country">Perú</h2>
					<h4 class="city">Lima</h4>
					<p class="text">{{ phone }}</p>
					<p class="text">Calle Independencia  106,  Piso 10</p>
					<p class="text two-line">Miraflores</p>
				</v-flex>
				<v-flex xs12 md4>
					<h2 class="country">Ecuador</h2>
					<h4 class="city">Latacunga</h4>
					<p class="text">{{ phoneEcu }}</p>
					<p class="text">AV. UNIDAD NACIONAL Y GABRIELA MISTRAL. EDIF. FENIX CORP. <br/> 
						Matríz Centro Tecnológico Latacunga.</p>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	function data() {
		return {
			phone: process.env.PHONE,
			phoneEcu: process.env.PHONE_ECU,
		};
	}
	export default {
		name: 'section-addresses',
		data,
	};
</script>

<style lang="scss" scoped>
	.section-addresses {
		padding: 40px 5%;

		@media (min-width: 360px) {
			padding: 40px 8%;
		}

		@media (min-width: 768px) {
			padding: 40px 10%;
		}
	}

	.country {
		font-size: size(large);
		font-weight: weight(w800);
		margin-bottom: 10px;
	}

	.city {
		font-size: size(medium16);
		font-weight: weight(w800);
		margin-bottom: 10px;
	}

	.text {
		margin: 0px;
		line-height: 1;
	}

	.two-line {
		margin-bottom: 37px;

		@media (min-width: 1024px) {
			margin-bottom: 0px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-addresses.vue